import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import {  AddSports, getLocationList, CheckCreatePartner  } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

class verticalAFADetail extends Component {
constructor(props) {
        super(props);
        this.state = {
            name_parm: this.props.match.params.type,
            infoDetails: [],
            partnercreation:false
        }
        this.id = this.props.match.params.id;
        this.type = this.props.match.params.type;
        this.openPartnerCreate = this.openPartnerCreate.bind(this);
        this.infoDetails = this.infoDetails.bind(this);
    }

    componentDidMount() {
        console.log(this.props);
        this.infoDetails();
    }

    getPageTitle(title) {
        let activityTitle = '';
        switch (title) {
            case "tution":
                activityTitle = 'Tution Info';
                break;

            case "music":
                activityTitle = 'Music Info';
                break;

            case "sports":
                activityTitle = 'Sports Info';
                break;

            case "dance":
                activityTitle = 'Dance Info';
                break;

            case "drawing":
                activityTitle = 'Drawing Info';
                break;
            case "yoga":
                activityTitle = 'Yoga Info';
                break;

            default:
                activityTitle = title;
        }
        return activityTitle;
    }

    UNSAFE_componentWillMount() {

    }

    componentDidUpdate() {
    }

    async infoDetails() {
        let response = await FetchCall.getCreativeActivitiesInfo(this.id);
        if (response) {
            const data = response.data;
            this.setState({
                infoDetails: data,
                url: data.url,
                photos_arr: data.photo_arr,
            });

        } else {
            return <div>Error</div>;
        }
    }

    gallery_image() {

        let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
        let rows = "";
        if (photos.length > 0) {
            rows = photos.map((photos, index) => {
                if (photos.name)
                    return (
                        <div class="col-md-4 float-left mt-4 p-0">
                            <img style={{ 'width': '70%' }} src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
                        </div>
                    );
            });
        } else {
            rows = "";
        }
        return rows;

    }


    openPartnerCreate(){
          this.setState({partnercreation:true});
    }

    handleChange = (e) => {
            this.setState({ [e.target.name]: e.target.value });
        
    };

    handleCreateSubmit = (e) => {
        e.preventDefault();
        
            let subData = JSON.stringify({
                id: this.id,
                user_type:1,
                table:'bw_hobby_interest',
                plan:this.state.plan,
                organisation_name:this.state.organisation_name,
                username:this.state.username,
                amount:this.state.amount,
                first_name:this.state.first_name,
                last_name:this.state.last_name,
                razorpay_payment_id:this.state.razorpay_payment_id,
                enddate:this.state.enddate
            });
            // jQuery("#btnSubmit").attr('disabled', true);
            
            CheckCreatePartner(subData).then((res) => {
                let toastr = '';
                if (res.status === 1) {
                    toastr = window.toastr.success;
                    toastr('', res.message, {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                    window.location.href = document.referrer;

                } else {
                    jQuery("#btnSubmit").attr('disabled', false);
                    toastr = window.toastr.error; //warning
                    toastr('Error', 'Something went wrong. try again!...', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                }
            }); 
        
    };

    render() {

        const { infoDetails } = this.state;
        console.log('infoDetails', this.state);
        console.log('activityTitle', this.state.activityTitle);




        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{infoDetails.organisation_name} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        
                       <form className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Registration No.</label>
                                                            <p>{infoDetails.registration_no}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label className="text-capitalize">Sports Academy Name </label>
                                                            <p>{infoDetails.organisation_name}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label className="text-capitalize">Sub Categories</label>
                                                            <p>{infoDetails.sub_categories}</p>
                                                        </div>


                                                        {/* <div className="form-group col-md-4">
                                                            <label className="text-capitalize">Type</label>
                                                            <p>{infoDetails.subtypes}</p>
                                                        </div> */}

                                                    </div>
                                                </div>



                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Address Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Email Id</label>
                                                            <p>{infoDetails.email_id}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Phone Number</label>
                                                            <p>{infoDetails.phone_number}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Website</label>
                                                            <p>{infoDetails.website}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>State</label>
                                                            <p>{infoDetails.state}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Location</label>
                                                            <p>{infoDetails.location}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Country</label>
                                                            <p>{infoDetails.country}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Area</label>
                                                            <p>{infoDetails.area}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Pincode</label>
                                                            <p>{infoDetails.pincode}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Address</label>
                                                            <p>{infoDetails.address}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Google Location Address</label>
                                                            <p>{infoDetails.google_location}</p>
                                                        </div>
                                                        <div className="form-group col-md-12">
                                                            <label>About</label>
                                                            <p>{infoDetails.about}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Type</label>
                                                            <p>{infoDetails.typname}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Class Frequency</label>
                                                            <p>{infoDetails.class_frequency}</p>
                                                        </div>
                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <label>Age Group</label>
                                                            <p>{infoDetails.min_age}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Number of Coaches</label>
                                                            <p>{infoDetails.number_of_trainee}</p>
                                                        </div>

                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <label>From Timing</label>
                                                            <p>{infoDetails.dfrom_time}</p>
                                                            <div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group col-md-4 input-group-cus">
                                                            <label>To Timing</label>
                                                            <p>{infoDetails.dto_time}</p>
                                                        </div>


                                                        <div className="form-group col-md-4">
                                                            <label>Establishment Year </label>
                                                            <p>{infoDetails.establishment_Year}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Average Fees(INR) </label>
                                                            <p>{infoDetails.avg_anual_fee}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Admission Fees </label>
                                                            <p>{infoDetails.addmission_fee}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Student Ratio</label>
                                                            <p>{infoDetails.stdratio}</p>
                                                        </div>
                                                        {(infoDetails.vendor_id == 1 && (
                                                            <div className="form-group col-md-4">
                                                                <label>Partner Type</label>
                                                                <p>{infoDetails.partner_type == 1 ? 'Institution' : 'Individual'}</p>
                                                            </div>
                                                        ))}
                                                        <div className="form-group col-md-4">
                                                            <label>Website Search Keywords</label>
                                                            <p>{infoDetails.keywords}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Other Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Other Info </label>
                                                            <p>{infoDetails.other_info }</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Video learning</label>
                                                            <p>{(infoDetails.video_leaning == 1) ? 'Yes' : 'No'}</p>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-12">
                                                            <label>Banner</label>


                                                        </div>
                                                        {infoDetails.images &&
                                                            <div className="form-group col-md-4">
                                                                <img style={{ 'width': '70%' }} src={infoDetails.url + infoDetails.images} alt="Img" class="img-thumbnail" />
                                                            </div>
                                                        }


                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label>
                                                                Gallery Images
                                                            </label>
                                                        </div>

                                                        {this.gallery_image()}
                                                    </div>
                                                </div>

                                            </form>
 
                                        

                       
               
                  </div>


                    <div class="row">
                                    <div class="col-md-12"><button class="btn btn-primary btn-sm" onClick={this.openPartnerCreate}>Create Partner</button></div>
                    </div>


            <Modal isOpen={this.state.partnercreation} size='lg' className='partnercreation-pop'>
                <ModalBody className='p-0'>
                    
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                                  <h3>Partner Creation Info</h3>
                                  <br/>
                                  <div class="form-row">
                                    <div class="form-group col-md-6">
                                      <label for="inputEmail4">Organization Name</label>
                                      <input type="text" class="form-control" id="organisation_name" name="organisation_name" placeholder="Organization Name" onChange={this.handleChange}/>
                                    </div>
                                    <div class="form-group col-md-6">
                                      <label for="inputPassword4">Username</label>
                                      <input type="text" class="form-control" id="username" name="username" placeholder="Username" onChange={this.handleChange}/>
                                    </div>
                                  </div>
                                  <div class="form-row">
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress">First Name</label>
                                    <input type="text" class="form-control" id="first_name" name="first_name"  placeholder="First Name" onChange={this.handleChange}/>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress2">Last Name</label>
                                    <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" onChange={this.handleChange}/>
                                  </div>
                                   </div>

                                   <div class="form-row">
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress">Amount Received</label>
                                    <input type="text" class="form-control" id="amountrecevied" name="amount"  placeholder="Amount" onChange={this.handleChange}/>
                                  </div>
                                  <div class="form-group col-md-6">
                                    <label for="inputAddress2">Payment Link</label>
                                    <input type="text" class="form-control" id="razorpay_payment_id" name="razorpay_payment_id" placeholder="Payment Link" onChange={this.handleChange}/>
                                  </div>
                                   </div>
                                  <div class="form-row">
                                    
                                    <div class="form-group col-md-4">
                                      <label for="inputState">Extend</label>
                                      <select id="inputState" class="form-control" name="enddate" onChange={this.handleChange}>
                                        <option selected>Choose...</option>
                                        <option value="2023-06-30">June 2023</option>
                                        <option value="2023-07-31">July 2023</option>
                                        <option value="2023-08-30">August 2023</option>
                                        <option value="2023-09-31">Sep 2023</option>
                                        <option value="2023-10-30">Oct 2023</option>
                                        <option value="2023-11-31">Nov 2023</option>
                                        <option value="2023-12-30">Dec 2023</option>
                                      </select>
                                    </div>

                                    <div class="form-group col-md-4">
                                     <label for="inputState">Plan</label>
                                      <select id="inputState" class="form-control" name="plan" onChange={this.handleChange}>
                                        <option selected>Choose...</option>
                                        <option value="3">Value Pro</option>
                                        <option value="4">Magic</option>
                                      </select>
                                   </div>
                                    
                                  </div>
                                  
                                                               

                        </Col>
                    </Row>
                    
                    <Row className='pv-section'>
                        <Col className='' md='12'>
                            <button className='btn btn-sm btn-primary custome-submit' onClick={this.handleCreateSubmit}>
                                Submit
                            </button>
                            
                            <button className='btn btn-sm btn-defult custome-submit' style={{ marginLeft: '10px' }}
                                onClick={() => { this.setState({ partnercreation: false }) }}>Close</button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal >

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalAFADetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalAFADetail.jsx